import React, { useState,useRef, useEffect } from 'react';
import { Box, Typography, Button, CircularProgress, Card, CardContent,Select,MenuItem} from '@mui/material';

const CodeOutput = ({rightBottomButtonList,handleButtonClick,rightBottomActiveButton,testCases,activeCaseButton,submitStatus,outputs,handleCaseClick,modelOutput,wrongTestCases}) => {
  return (
    <Box sx={{ backgroundColor: '#181719', borderRadius: '10px',marginTop:'2px',zIndex:1000,height:'100%'}}>
        <Box
            sx={{
            backgroundColor: '#36343B',                
            height: '45px',
            display: 'flex',
            alignItems: 'center',
            padding: '10px',            
            }}
            >
            {rightBottomButtonList.map((buttonName) => (
                <Button
                    key={buttonName}
                    variant="text"
                    onClick={() => handleButtonClick(buttonName,"rightBottom")}
                    sx={{
                    color: '#181719',
                    height: '30px',                      
                    borderBottom: rightBottomActiveButton === buttonName ? '2px solid white' : 'none', 
                    marginRight: '10px',
                    borderRadius: '0px',
                    '&:hover': {
                        backgroundColor: '#372D43', 
                    },
                    }}
                >
                    <Typography sx={{ color: 'white' }}>{buttonName}</Typography>
                </Button>
            ))}
        </Box>
        <Box>
            {rightBottomActiveButton === 'Output' && (
            <Box>                  
                {testCases && testCases.map((testCase, i) => (
                <Button
                    key={i}
                    variant="text"
                    onClick={() => handleCaseClick(i)}
                    sx={{
                    color: submitStatus
                    ? (!wrongTestCases.includes(i) ? 'green' : 'red')  
                    : (wrongTestCases.includes(i) ? 'red' : 'white'),
                    marginTop: '10px',
                    marginRight: '7px',
                    marginLeft: '7px',
                    backgroundColor: activeCaseButton === i ? '#36343B' : 'transparent',
                    '&:hover': {
                        backgroundColor: '#36343B',
                    },
                    }}
                >
                    <Typography sx={{ textTransform: 'none' }}>
                    Case {i + 1}
                    </Typography>
                </Button>
                ))}
                {submitStatus && (
                <>
                    <Typography sx={{ color: "white", marginTop: '10px', marginLeft: '7px' }}>
                    Input:                     
                    </Typography>
                    <Box sx={{
                    backgroundColor:"#36343B",
                    width:"95%",
                    minHeight:"30px",
                    marginLeft:'7px',
                    borderRadius:'4px',
                    display:'flex',
                    alignItems:'center'}}>
                    <Typography sx={{ color: "white", marginLeft: '7px' }}>
                        {Object.keys(testCases[activeCaseButton]).map((key) => (
                        <Typography key={key}>
                            {key}: {testCases[activeCaseButton][key]}
                        </Typography>
                        ))}                    
                    </Typography>
                    </Box>

                    <Typography sx={{ color: 'white', marginTop: '10px', marginLeft: '7px' }}>
                    Your Output: 
                    </Typography>
                    <Box sx={{
                    backgroundColor:"#36343B",
                    width:"95%",
                    minHeight:"30px",
                    marginLeft:'7px',
                    borderRadius:'4px',
                    display:'flex',
                    alignItems:'center'}}>
                    <Typography sx={{ color: "white", marginLeft: '7px' }}>
                        {outputs[activeCaseButton]}                    
                    </Typography>
                    </Box>

                    <Typography sx={{ color: 'white', marginTop: '10px', marginLeft: '7px' }}>
                    Expected Output: 
                    </Typography>
                    <Box sx={{
                    backgroundColor:"#36343B",
                    width:"95%",
                    minHeight:"30px",
                    marginLeft:'7px',
                    borderRadius:'4px',
                    display:'flex',
                    alignItems:'center'}}>
                    <Typography sx={{ color: "white", marginLeft: '7px' }}>
                        {modelOutput[activeCaseButton]}                    
                    </Typography>
                    </Box>
                </>
                )}
                

            
            </Box>
            )}
            {rightBottomActiveButton === 'Test Case' && testCases && (
            <>
                <Box>
                {testCases && testCases.map((testCase, i) => (
                    <Button
                    key={i}
                    variant="text"
                    onClick={() => handleCaseClick(i)}
                    sx={{
                        color: 'white',
                        marginTop: '10px',
                        marginRight: '7px',
                        marginLeft: '7px',
                        backgroundColor: activeCaseButton === i ? '#36343B' : 'transparent',
                        '&:hover': {
                        backgroundColor: '#36343B',
                        },
                    }}
                    >
                    <Typography sx={{ textTransform: 'none' }}>
                        Case {i + 1}
                    </Typography>
                    </Button>
                ))}

                {testCases && testCases[activeCaseButton] && (
                    <Box sx={{
                        backgroundColor: "#36343B",
                        width: "95%",
                        maxHeight: "310px",
                        overflowY: "auto",
                        marginTop: "10px",
                        marginLeft: '7px',
                        borderRadius: '4px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '10px'
                    }}>
                    <Typography sx={{ color:'white', marginLeft: '7px' }}>
                        
                        {Object.keys(testCases[activeCaseButton]).map((key) => (
                                <Typography key={key}>
                                    {key}: {testCases[activeCaseButton][key]}
                                </Typography>
                                ))}                    
                    </Typography>

                    </Box>
                    
                    )}

                
                </Box>
                
            </>
            )}            
        </Box>
            
    </Box>
  )
}

export default CodeOutput